import 'css-chunksrc/client/common/circularProgressBar/styles.scss';export default {
  "progress-bar": "_progress-bar_1fhae_1",
  "bar": "_bar_1fhae_6",
  "progress": "_progress_1fhae_1"
};